import { PermissionState } from '@app/store/typings/state/permission';
import { PermissionType } from '@app/store/typings/actions/permission';

const initialState: PermissionState = {
  brand: [{ description: '', level: '', name: '', value: '' }],
  project: [{ description: '', level: '', name: '', value: '' }],
  resource: [{ description: '', level: '', name: '', value: '' }],
};

export const permission = (state = initialState, action: PermissionType) => {
  switch (action.type) {
    case 'KEY_PERMISSION_BRAND_SETDATA':
      state.brand = action.payload;
      return { ...state };
    case 'KEY_PERMISSION_BRAND_CLEAR':
      state.brand = [];
      return { ...state };
    case 'KEY_PERMISSION_PROJECT_SETDATA':
      state.project = action.payload;
      return { ...state };
    case 'KEY_PERMISSION_PROJECT_CLEAR':
      state.project = [];
      return { ...state };
    default:
      return state;
  }
};
